package com.ijoin.data.push

import com.ijoin.data.model.PushPlatform

object PushTokenRegistrar {
    private val manager = PushTokenManager()

    fun register(token: String, platform: PushPlatform, deviceName: String? = null) {
        manager.submitToken(token, platform, deviceName)
    }

    fun unregister(token: String? = null) {
        manager.invalidateToken(token)
    }

    /**
     * Should be invoked whenever an auth token becomes available (login/register/refresh)
     * so that any pending push tokens get synced to the backend.
     */
    fun notifyAuthenticated() {
        manager.onAuthenticationAvailable()
    }
}
